import AlternateBoldText from 'components/shared/AlternateBoldText';
import useQueryParam from 'hooks/useQueryParam';
import type { FunctionComponent } from 'react';
import { formatToCurrency } from 'utils/Finance-functions';
import { FinanceInfo } from '../types';
import { TEXT } from './constants';

export interface FooterProps {
  financeInfo: FinanceInfo;
}

const Footer: FunctionComponent<FooterProps> = function ({ financeInfo }) {
  const {
    formCompleted,
    apr,
    amountOfCredit,
    duration,
    monthlyPayment,
    totalPayable,
    deferredDuration,
  } = financeInfo;
  const [iar] = useQueryParam('iar');
  const hasProvidedIar = iar && iar !== 'null';
  const formattedIar = hasProvidedIar && iar.replace(/\+/g, ' ');

  const prefix = (
    hasProvidedIar
      ? [
          '',
          formattedIar,
          ` is an Introducer Appointed Representative of Kanda. ${TEXT}.`,
        ]
      : [TEXT]
  ) as string[];

  const representativeExample = (
    formCompleted
      ? [
          ...prefix,
          '',
          ` Representative example: based upon a loan of `,
          `${formatToCurrency(amountOfCredit)}`,
          ...(deferredDuration
            ? [
                ' repayable after an initial interest free term of ',
                `${deferredDuration}`,
                ' months followed by monthly repayments over ',
              ]
            : [' repayable over ']),
          `${duration}`,
          ' months at an interest rate of ',
          `${apr / 100}%`,
          ' APR representative per annum (fixed). Monthly repayment of ',
          `${formatToCurrency(monthlyPayment)}`,
          '. Total amount payable ',
          `${formatToCurrency(totalPayable)}`,
        ]
      : prefix
  ) as string[];

  return (
    <div className="mt-2 text-sm text-neutral-700">
      <AlternateBoldText text={representativeExample} />
    </div>
  );
};

export default Footer;
